/**
 * Converts any given ISO-8601 compliant string or Date object into a UTC based timestamp (milliseconds since 1.1.1970).
 * Replaces the slow "moment.utc(iso8601StringOrDate).valueOf()" call.
 *
 * @param {string|Date} iso8601StringOrDate
 * @returns {number}
 */
export function toUtcTimestamp(iso8601StringOrDate) {
    return new Date(iso8601StringOrDate).getTime()
}
